import { OmyConst } from "../../OmyConst";
import Omy from "../../Omy";
import OMap from "../../utils/OMap";
import PlayListData from "./parts/PlayListData";

export default class OActor extends PIXI.AnimatedSprite {
    constructor(textureArray, nameAnimation) {
        super(textureArray, nameAnimation);

        this._onKillEvent = "kill_event";
        this._onReviveEvent = "revive_event";
        this._onDestroyEvent = "destroy_event";
        this._onDownEvent = "down_event";
        this._onUpEvent = "up_event";
        this._onUpOutSideEvent = "up_out_event";
        this._onOverEvent = "over_event";
        this._onOutEvent = "out_event";
        this._onDragStartEvent = "drag_start_event";
        this._onDragStopEvent = "drag_stop_event";
        this._onDragUpdateEvent = "drag_update_event";
        this._onCompleteEvent = "complete_event";
        this._onLoopEvent = "loop_event";
        this._onEndAnimationEvent = "end_animation_event";
        this._onFrameChangeEvent = "frame_change_event";

        this._saveVisible = true;
        /**         * @type {Object}         */
        this.userData = null;
        /**         * @type {Boolean}         */
        this._active = true;
        this.numChildren = 0;
        this._oX = 0;
        this._oY = 0;
        this._oWidth = 0;
        this._oHeight = 0;

        this._putOnCache = true;

        /**         * @type {Array}         */
        this._externalMethodParams = null;
        /**         * @type {Function}         */
        this._externalMethod = null;
        this._isDrag = false;
        this._dragVertical = false;
        this._dragHorizontal = false;
        this._isStartDrag = false;
        this._isCheckInput = false;

        this.autoReviveChildren = true;
        this.needAutoRevive = false;

        this._boundsRect = new OmyConst.Rectangle();
        this._localBoundsRect = new OmyConst.Rectangle();

        this._oType = OmyConst.OMY_ACTOR;
        this.anchor.set(.5);

        this._removeOnEnd = false;
        this.onComplete = this._onCompleteHandler.bind(this);
        this.onLoop = this._onLoopHandler.bind(this);
        this._countLoop = 0;
        this._totalLoop = Number.MAX_VALUE;
        this._reverseActor = false;
        this._map = new OMap();
        this._map.set(nameAnimation, textureArray);
        this._aName = nameAnimation;
        this._frameFncList = null;
        this._allowFrameFnc = false;

        /** @type {PlayListData} */
        this._currentPlayList = null;
        this._playListData = null;
        this._fpsGame = Omy.fps;
        this._fps = Omy.fps;
        this._playPlayList = false;
        this.interactChild = false;
        this._isRevert = false;

        this.onFrameChange = this._onFrameChangeHandler.bind(this);
        if (Omy.debugMode) {
            this._isOnDebugerUpdate = true;
            Omy.addUpdater(this._updateDebug, this);
        }
        this.aa_isRegOnDebug = false;
        this._inDebug = false;
    }

    /**     * @private     */
    _updateDebug() {
        if (this.aa_isRegOnDebug && !this._inDebug) {
            Omy.add.regDebugMode(this);
        } else if (!this.aa_isRegOnDebug && this._inDebug) {
            Omy.add.removeFromDebug(this);
        }
    }

    /**     * @private     */
    _onCompleteHandler() {
        if (this._reverseActor) {
            this.textures.reverse();
            if (!this._reverseVector) {
                this.emit(this._onCompleteEvent, this);
                if (this._removeOnEnd) {
                    this.kill();
                }
            } else {
                this.play();
            }
            this._reverseVector = !this._reverseVector;
        } else {
            if (this._playPlayList) {
                if (this._currentPlayList.isFinish) {
                    this.stopPlayList();
                    this.emit(this._onCompleteEvent, this);
                    if (this._removeOnEnd) {
                        this.kill();
                    }
                } else {
                    this.emit(this._onEndAnimationEvent, this, this._currentPlayList.id);
                    this._currentPlayList.next();
                }
            } else {
                this.emit(this._onCompleteEvent, this);
                if (this._removeOnEnd) {
                    this.kill();
                }
            }
        }
    }

    /**     * @private     */
    _onLoopHandler() {
        if (this._reverseActor) {
            this.textures.reverse();
            if (!this._reverseVector) {
                this.emit(this._onLoopEvent, this);
                if (++this._countLoop >= this._totalLoop) {
                    this.loop = false;
                    this.stop();
                    this.emit(this._onCompleteEvent, this);
                    if (this._removeOnEnd) {
                        this.kill();
                    }
                }
            }
            this._reverseVector = !this._reverseVector;
        } else {
            this.emit(this._onLoopEvent, this);
            if (++this._countLoop >= this._totalLoop) {
                if (this._playPlayList) {
                    if (this._currentPlayList.isFinish) {
                        this.stopPlayList();
                        this.stop();
                        this.emit(this._onCompleteEvent, this);
                        if (this._removeOnEnd) {
                            this.kill();
                        }
                    } else {
                        this.emit(this._onEndAnimationEvent, this, this._currentPlayList.id);
                        this._currentPlayList.next();
                    }
                } else {
                    this.loop = false;
                    this.stop();
                    this.emit(this._onCompleteEvent, this);
                    if (this._removeOnEnd) {
                        this.kill();
                    }
                }
            }
        }
    }

    /**     * @public     */
    addFramesList(data) {
        this._framesList = data;
    }

    /**     * @public     */
    playFromFramesList(name) {
        if (this._framesList && this._framesList[name]) {
            this._nameActiveFrame = this._framesList[name];
            this._isPlayFrameList = true;
            this.gotoAndPlay(this._nameActiveFrame["start"], Boolean(this._nameActiveFrame["loop"]));
        }
    }

    /**     * @public     */
    clearPlayFromFrames() {
        if (this._isPlayFrameList) {
            this._isPlayFrameList = false;
            this._nameActiveFrame = null;
        }
    }

    /**     * @public     */
    addPlayList(playData) {
        if (!this._playListData) this._playListData = new OMap();
        if (!playData) {
            Omy.error("pls, add not null data", this);
            return;
        }

        let data,
            oArray,
            dataArray,
            animO;
        for (let playDataKey in playData) {
            if (this._playListData.has(playDataKey)) {
                continue;
            }

            dataArray = [];
            oArray = playData[playDataKey];
            for (let i = 0; i < oArray.length; i++) {
                animO = oArray[i];
                data = {
                    name: animO["name"],
                    loop: animO["loop"] || false,
                    speed: animO["speed"] || 1,
                    totalLoop: animO["totalLoop"] || Number.MAX_VALUE
                };
                dataArray.push(data);
            }
            this._playListData.set(playDataKey, dataArray);
        }
    }

    setDelayPlayList(time = 0, nameList = "", onComplete = null) {
        if (this._delayTimer) this._delayTimer.destroy();
        this._saveNameList = nameList;
        this._saveDelayOnComplete = onComplete;
        this._delayTimer = Omy.add.timer(time, this._onCompleteDelayPlayList, this);
    }

    _onCompleteDelayPlayList() {
        this._delayTimer = null;
        this.playList(this._saveNameList);
        this._saveNameList = null;
        if (this._saveDelayOnComplete) {
            this._saveDelayOnComplete(this);
            this._saveDelayOnComplete = null;
        }
    }

    setDelayPlay(time = 0, looping = false, onComplete = null) {
        if (this._delayTimer) this._delayTimer.destroy();
        this._saveDelayLoop = looping;
        this._saveDelayOnComplete = onComplete;
        this._delayTimer = Omy.add.timer(time, this._onCompleteDelayPlay, this);
    }

    _onCompleteDelayPlay() {
        if (!this.visible) this.visible = true;
        this._delayTimer = null;
        this.play(this._saveDelayLoop);
        if (this._saveDelayOnComplete) {
            this._saveDelayOnComplete(this);
            this._saveDelayOnComplete = null;
        }
    }

    setDelayGotoAndPlay(time = 0, frame = 0, looping = false, onComplete = null) {
        if (this._delayTimer) this._delayTimer.destroy();
        this._saveDelayLoop = looping;
        this._saveDelayFrame = frame;
        this._saveDelayOnComplete = onComplete;
        this._delayTimer = Omy.add.timer(time, this._onCompleteDelayGotoAndPlay, this);
    }

    _onCompleteDelayGotoAndPlay() {
        if (!this.visible) this.visible = true;
        this._delayTimer = null;
        this.gotoAndPlay(this._saveDelayFrame, this._saveDelayLoop);
        if (this._saveDelayOnComplete) {
            this._saveDelayOnComplete(this);
            this._saveDelayOnComplete = null;
        }
    }

    play(looping = false, animName = null) {
        if (animName)
            this.changeAnimation(animName);
        this._countLoop = 0;
        this._prevFrame = this.currentFrame;
        super.play();
        this.loop = looping;
        return this;
    }

    stop() {
        super.stop();
        return this;
    }

    gotoAndPlay(frame = 0, looping = false, animName = null) {
        if (animName)
            this.changeAnimation(animName);
        this._countLoop = 0;
        this._prevFrame = this.currentFrame;
        super.gotoAndPlay(frame);
        this.loop = looping;
        return this;
    }

    gotoAndStop(frame = 0, animName = null) {
        if (animName)
            this.changeAnimation(animName);
        this._prevFrame = this.currentFrame;
        super.gotoAndStop(frame);
        return this;
    }

    restart() {
        super.gotoAndPlay(0);
        return this;
    }

    reverse() {
        this._reverseActor = true;
        this._reverseVector = true;
        return this;
    }

    next() {
        let nextFrame = this.currentFrame + 1;
        if (nextFrame >= this.totalFrames) nextFrame = 0;

        super.gotoAndStop(nextFrame);
        return this;
    }

    previous() {
        let nextFrame = this.currentFrame - 1;
        if (nextFrame < 0) nextFrame = this.totalFrames - 1;

        super.gotoAndStop(nextFrame);
        return this;
    }

    /**     * @public     */
    playList(namePlayList) {
        if (!this._playListData) {
            Omy.error("pls, first add playListData", this);
            return;
        }
        if (!this._playListData.has(namePlayList)) {
            Omy.warn("this playList name is not exist:", namePlayList);
            return;
        }

        if (!this._currentPlayList)
            this._currentPlayList = new PlayListData(this);
        this._currentPlayList.setData(this._playListData.get(namePlayList));
        this._playPlayList = true;
        this._currentPlayList.startPlay();
    }

    /**     * @public     */
    stopPlayList() {
        this._playPlayList = false;
        this._currentPlayList.clear();
    }

    addAnimation(aName, textureArray) {
        if (!this.hasAnimation(aName)) {
            this._map.set(aName, textureArray);
        }
    }

    changeAnimation(aName) {
        if (!this.hasAnimation(aName)) {
            this.textures = Omy.assets.getAnimation(aName);
        } else {
            this.textures = this._map.get(aName);
        }
        this._aName = aName;
        return this;
    }

    hasAnimation(aName) {
        return this._map.has(aName);
    }

    addFrameFunction(frameId, func) {
        if (!this._allowFrameFnc) {
            this._allowFrameFnc = true;
            this._frameFncList = [];
        }
        this._frameFncList[frameId] = func;

        return this;
    }

    /**
     * @public
     * @param frameId, default=-1, clear all
     */
    clearFrameFunction(frameId = -1) {
        if (frameId === -1) {
            this._allowFrameFnc = false;
            this._frameFncList.length = 0;
            this._frameFncList = null;
        } else {
            this._frameFncList[frameId] = null;
        }

        return this;
    }

    /**     * @private     */
    _onFrameChangeHandler() {
        if (this.playing) {
            if (this._allowFrameFnc) {
                if (this._prevFrame < this.currentFrame) {
                    for (let i = this._prevFrame + 1; i <= this.currentFrame; i++) {
                        if (this._frameFncList[i]) {
                            this._frameFncList[i](this);
                        }
                    }
                } else if (this._prevFrame > this.currentFrame) {
                    for (let i = this._prevFrame + 1; i < this.totalFrames; i++) {
                        if (this._frameFncList[i]) {
                            this._frameFncList[i](this);
                        }
                    }
                    for (let i = 0; i <= this.currentFrame; i++) {
                        if (this._frameFncList[i]) {
                            this._frameFncList[i](this);
                        }
                    }
                }
            }
            if (this._isPlayFrameList) {
                if (this._nameActiveFrame["end"] === this.currentFrame) {
                    if (this._nameActiveFrame["loop"]) {
                        this.gotoAndPlay(this._nameActiveFrame["start"], Boolean(this._nameActiveFrame["loop"]));
                        this.emit(this._onLoopEvent, this);
                    } else {
                        this.stop();
                        this.clearPlayFromFrames();

                        if (this._removeOnEnd) {
                            this.kill();
                        }
                        this.emit(this._onCompleteEvent, this);
                    }
                }
            }
        }

        this.emit(this._onFrameChangeEvent, this.currentFrame, this._prevFrame);
        this._prevFrame = this.currentFrame;
    }

    /**     * @public     */
    addChild(child) {
        super.addChild(child);
        this.numChildren = this.children.length;
        return child;
    }

    /**     * @public     */
    addChildAt(child, index) {
        super.addChildAt(child, index);
        this.numChildren = this.children.length;
        return child;
    }

    /**     * @public     */
    removeChild(child) {
        super.removeChild(child);
        this.numChildren = this.children.length;
        return child;
    }

    /**     * @public     */
    removeChildAt(index) {
        let child = super.removeChildAt(index);
        this.numChildren = this.children.length;
        return child;
    }

    /**     * @public     */
    removeChildren(beginIndex, endIndex) {
        let res = super.removeChildren(beginIndex, endIndex);
        this.numChildren = this.children.length;
        return res;
    }

    /**
     * @param {PIXI.DisplayObject} child
     * @returns {boolean}
     */
    contains(child) {
        if (this.children == null) {
            return false;
        }

        return this.children.indexOf(child) >= 0;
    }

    /**     * @public     */
    kill() {
        if (this._active) {
            this._active = false;
            if (this._isOnDebugerUpdate) {
                this._isOnDebugerUpdate = false;
                Omy.removeUpdater(this._updateDebug, this);
            }

            if (this.children != null) {
                let i = 0;
                let m = this.numChildren;
                let o;
                while (i < this.numChildren && this.numChildren) {
                    o = this.children[i++];
                    if (o.active && o.kill) {
                        o.kill();
                    }
                    if (m !== this.numChildren) {
                        m--;
                        i--;
                    }
                }
            }

            if (this.input)
                this.input = false;

            if (this.playing) {
                this.stop();
            }

            this.clearPlayFromFrames();

            if (this._putOnCache) {
                if (this._isRevert) {
                    this.textures.reverse();
                    this._isRevert = false;
                }
                this.changeAnimation(this._aName);
                this.gotoAndStop(0);

                this._playPlayList = false;
                if (this._currentPlayList) {
                    this._currentPlayList.clear();
                }
                if (this._delayTimer) this._delayTimer.destroy();
                this._delayTimer = null;
                this._saveDelayOnComplete = null;
                this.scaleX = 1;
                this.scaleY = 1;
                this.angle = 0;
                this.alpha = 1;
                this.rotation = 0;
                this.x = 0;
                this.y = 0;
                this._removeOnEnd = false;
                this.removeAllListeners(this._onCompleteEvent);
                this.removeAllListeners(this._onLoopEvent);
                this.removeAllListeners(this._onEndAnimationEvent);

                if (this._allowFrameFnc) {
                    this.clearFrameFunction();
                }

                this.emit(this._onKillEvent, this);
                this.removeAllListeners(this._onKillEvent);
                Omy.remove.actorAtlas(this);

            }
            this._saveVisible = this.visible;
            this.visible = false;
            this.renderable = false;
            this.emit(this._onKillEvent, this);
        }
        return this;
    }

    /**     * @public     */
    revive() {
        if (!this._active) {
            this._active = true;
            this.renderable = true;
            if (Omy.debugMode && !this._isOnDebugerUpdate) {
                this._isOnDebugerUpdate = true;
                Omy.addUpdater(this._updateDebug, this);
            }

            if (this.children != null) {
                let i = 0;
                let o;
                while (i < this.numChildren) {
                    o = this.children[i++];
                    if ((this.autoReviveChildren || o.needAutoRevive) && !o.active && o.revive) {
                        o.revive();
                    }
                }
            }

            if (this.input)
                this.input = true;
            this.visible = this._saveVisible;
            this.emit(this._onReviveEvent, this);
        }

        return this;
    }

    /**     * @public     */
    destroy(options) {
        options = options || { children: true, texture: false, baseTexture: false };
        if (this._delayTimer) this._delayTimer.destroy();
        this.json = null;
        this._delayTimer = null;
        this._saveDelayOnComplete = null;
        this._map.clear();
        this._map = null;
        if (this._playListData) {
            this._playListData.clear();
            this._playListData = null;
        }
        this.onFrameChange = null;
        if (this._framesList) {
            this._framesList = null;
            this.clearPlayFromFrames();
        }
        this._playPlayList = false;
        if (this._currentPlayList) {
            this._currentPlayList.destroy();
            this._currentPlayList = null;
        }

        if (this._allowFrameFnc) {
            this.clearFrameFunction();
        }
        if (this._isOnDebugerUpdate) {
            this._isOnDebugerUpdate = false;
            Omy.removeUpdater(this._updateDebug, this);
        }

        this._active = false;
        this.userData = null;
        this.numChildren = 0;
        this._boundsRect = null;
        this._localBoundsRect = null;
        this._isDrag = false;
        this._isStartDrag = false;
        if (this._listenMouseUp) {
            this._listenMouseUp = false;
            Omy.mouse.removeUpMouse(this._globalMouseUp, this);
        }
        this._aName = null;
        this._eventData = null;

        if (this.input) {
            this.input = false;
        }
        this.removeAllListeners(this._onDragStartEvent);
        this.removeAllListeners(this._onDragStopEvent);
        this.removeAllListeners(this._onDragUpdateEvent);
        this.removeAllListeners(this._onDownEvent);
        this.removeAllListeners(this._onOutEvent);
        this.removeAllListeners(this._onOverEvent);
        this.removeAllListeners(this._onUpEvent);
        this.removeAllListeners(this._onUpOutSideEvent);
        this.removeAllListeners(this._onCompleteEvent);
        this.removeAllListeners(this._onLoopEvent);
        this.removeAllListeners(this._onEndAnimationEvent);
        this.emit(this._onDestroyEvent, this);
        this.removeAllListeners(this._onDestroyEvent);
        this.removeAllListeners(this._onKillEvent);
        this.removeAllListeners(this._onReviveEvent);

        this._externalMethod = null;
        this._externalMethodParams = null;
        this.renderable = false;
        this.visible = false;

        super.destroy(options);
        return this;
    }

    /**     * @public     */
    update(deltaTime) {
        super.update(deltaTime);
        if (this._isStartDrag) {
            if (this._eventData.global.x !== this._dragSaveX || this._eventData.global.y !== this._dragSaveY) {
                if (this._dragHorizontal) {
                    this.x = this._oX + this._eventData.global.x - this._dragSaveX;

                    if (this._oX < this._dragXMin) {
                        this.x = this._dragXMin;
                    } else if (this._oX > this._dragXMax) {
                        this.x = this._dragXMax;
                    }
                }
                if (this._dragVertical) {
                    this.y = this._oY + this._eventData.global.y - this._dragSaveY;

                    if (this._oY < this._dragYMin) {
                        this.y = this._dragYMin;
                    } else if (this._oY > this._dragYMax) {
                        this.y = this._dragYMax;
                    }
                }
                this._dragSaveX = this._eventData.global.x;
                this._dragSaveY = this._eventData.global.y;
                this.emit(this._onDragUpdateEvent, this);
                if (!Omy.mouse.isDown) this._upOutSide();
            }
        }
    }

    _down(event) {
        if (this._isDrag) {
            this._eventData = event.data;
            this._dragSaveX = this._eventData.global.x;
            this._dragSaveY = this._eventData.global.y;
            this._isStartDrag = true;
            this.emit(this._onDragStartEvent, this);
        }

        this.emit(this._onDownEvent, this);
    }

    _over() {
        this.emit(this._onOverEvent, this);
    }

    _out() {
        this.emit(this._onOutEvent, this);
    }

    _upOutSide() {
        this._out();
        this.emit(this._onUpOutSideEvent, this);
    }

    _up() {
        this.emit(this._onUpEvent, this);

        if (this._externalMethod != null)
            this._externalMethod.apply(null, this._externalMethodParams);
    }

    _globalMouseUp() {
        if (this._isDrag && this._isStartDrag) {
            this._eventData = null;
            this._isStartDrag = false;
            this.emit(this._onDragStopEvent, this);
        }
    }

    /**
     * @param {String} aVariableName
     * @param {Object} aValue
     */
    setAll(aVariableName, aValue) {
        let i = 0;
        let o;
        while (i < this.numChildren) {
            o = this.children[i++];
            if (o != null) {
                o[aVariableName] = aValue;
            }
        }
    }

    /**
     * @param {String} aFunctionName
     * @param {Array} aArgs
     */
    callAll(aFunctionName, aArgs = null) {
        if (this.children != null) {
            let i = 0;
            let m = this.numChildren;
            let o;
            while (i < this.numChildren && this.numChildren) {
                o = this.children[i++];
                if (o) {
                    o[aFunctionName].apply(o, aArgs);
                }
                if (m !== this.numChildren) {
                    m--;
                    i--;
                }
            }
        }
    }

    setXY(ax, ay) {
        this._oX = ax;
        this._oY = ay;
        this.position.set(ax, ay);
    }

    setSize(ax, ay) {
        this.width = ax;
        this.height = ay;
    }

    setScale(ax, ay) {
        this.scale.set(ax, ay);
    }

    setAnchor(ax, ay) {
        this.anchor.set(ax, ay);
    }

    setPivot(ax, ay) {
        this.pivot.set(ax, ay);
        this.x = this._oX + ax;
        this.y = this._oY + ay;
    }

    /**
     * @param {Function}eMethod
     * @param {Array}methodParams
     */
    externalMethod(eMethod, methodParams) {
        if (!this.input)
            this.input = true;
        this._externalMethod = eMethod;
        this._externalMethodParams = methodParams;
    }

    boundsDragRect(rXMin = NaN, rYMin = NaN, rXMax = NaN, rYMax = NaN) {
        if (!isNaN(rXMin))
            this._dragXMin = rXMin;
        if (!isNaN(rYMin))
            this._dragYMin = rYMin;
        if (!isNaN(rXMax))
            this._dragXMax = rXMax;
        if (!isNaN(rYMax))
            this._dragYMax = rYMax;
    }

    addOver(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onOverEvent, func, context, once);
    }

    addOut(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onOutEvent, func, context, once);
    }

    addDown(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onDownEvent, func, context, once);
    }

    addUp(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onUpEvent, func, context, once);
    }

    addUpOutSide(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onUpOutSideEvent, func, context, once);
    }

    addDragUpdate(func, context, once) {
        this._addNewEvent(this._onDragUpdateEvent, func, context, once);
    }

    addDragStart(func, context, once) {
        this._addNewEvent(this._onDragStartEvent, func, context, once);
    }

    addDragStop(func, context, once) {
        this._addNewEvent(this._onDragStopEvent, func, context, once);
    }

    addKill(func, context, once) {
        this._addNewEvent(this._onKillEvent, func, context, once);
    }

    addRevive(func, context, once) {
        this._addNewEvent(this._onReviveEvent, func, context, once);
    }

    addDestroy(func, context, once) {
        this._addNewEvent(this._onDestroyEvent, func, context, once);
    }

    /**     * @private     */
    _addNewEvent(event, func, context, once = false) {
        if (once)
            this.once(event, func, context);
        else
            this.on(event, func, context);
    }

    addComplete(func, context, once) {
        this._addNewEvent(this._onCompleteEvent, func, context, once);
    }

    addLoop(func, context, once = false) {
        this._addNewEvent(this._onLoopEvent, func, context, once);
    }

    addEndAnimation(func, context, once = false) {
        this._addNewEvent(this._onEndAnimationEvent, func, context, once);
    }

    removeOver(func, context) {
        this.removeListener(this._onOverEvent, func, context);
    }

    removeOut(func, context) {
        this.removeListener(this._onOutEvent, func, context);
    }

    removeDown(func, context) {
        this.removeListener(this._onDownEvent, func, context);
    }

    removeUp(func, context) {
        this.removeListener(this._onUpEvent, func, context);
    }

    removeUpOutSide(func, context) {
        this.removeListener(this._onUpOutSideEvent, func, context);
    }

    removeDragUpdate(func, context) {
        this.removeListener(this._onDragUpdateEvent, func, context);
    }

    removeDragStart(func, context) {
        this.removeListener(this._onDragStartEvent, func, context);
    }

    removeDragStop(func, context) {
        this.removeListener(this._onDragStopEvent, func, context);
    }

    removeComplete(func, context) {
        this.removeListener(this._onCompleteEvent, func, context);
    }

    removeLoop(func, context) {
        this.removeListener(this._onLoopEvent, func, context);
    }

    removeEndAnimation(func, context) {
        this.removeListener(this._onEndAnimationEvent, func, context);
    }

    removeKill(func, context) {
        this.removeListener(this._onKillEvent, func, context);
    }

    removeRevive(func, context) {
        this.removeListener(this._onReviveEvent, func, context);
    }

    removDestroy(func, context) {
        this.removeDestroy(func, context);
    }

    removeDestroy(func, context) {
        this.removeListener(this._onDestroyEvent, func, context);
    }

//---------------------------------------
/// ACCESSOR
//--------------------------------------

    get active() {
        return this._active;
    }

    get scaleX() {
        return this.scale.x;
    }

    set scaleX(value) {
        this.scale.x = value;
    }

    get scaleY() {
        return this.scale.y;
    }

    set scaleY(value) {
        this.scale.y = value;
    }

    get pivotX() {
        return this.pivot.x;
    }

    set pivotX(value) {
        this.pivot.x = value;
    }

    get pivotY() {
        return this.pivot.y;
    }

    set pivotY(value) {
        this.pivot.y = value;
    }

    get anchorX() {
        return this.anchor.x;
    }

    set anchorX(value) {
        this.anchor.x = value;
    }

    get anchorY() {
        return this.anchor.y;
    }

    set anchorY(value) {
        this.anchor.y = value;
    }

    get localLeft() {
        return this._localBoundsRect.left;
    }

    get localRight() {
        return this._localBoundsRect.right;
    }

    get localTop() {
        return this._localBoundsRect.top;
    }

    get localBottom() {
        return this._localBoundsRect.bottom;
    }

    get localWidth() {
        return this._localBoundsRect.width;
    }

    get localHeight() {
        return this._localBoundsRect.height;
    }

    get globalLeft() {
        return this.getGlobalPosition().x + this.localLeft;
    }

    get globalTop() {
        return this.getGlobalPosition().y + this.localTop;
    }

    get worldX() {
        return this.getGlobalPosition().x;
    }

    get worldY() {
        return this.getGlobalPosition().y;
    }

    get x() {
        this._oX = super.x;
        return this._oX;
    }

    set x(value) {
        super.x = this._oX = value;
    }

    get y() {
        this._oY = super.y;
        return this._oY;
    }

    set y(value) {
        super.y = this._oY = value;
    }

    get height() {
        this._oHeight = super.height;
        return this._oHeight;
    }

    set height(value) {
        return super.height = this._oHeight = value;
    }

    get width() {
        this._oWidth = super.width;
        return this._oWidth;
    }

    set width(value) {
        return super.width = this._oWidth = value;
    }

    get oType() {
        return this._oType;
    }

    get input() {
        return this._isCheckInput;
    }

    set input(value) {
        if (this.input) {
            this.interactive = value;
        } else if (value) {
            this._isCheckInput = true;
            this.interactive = true;
            this.on("pointerdown", this._down, this);
            this.on("pointerup", this._up, this);
            this.on("pointerupoutside", this._upOutSide, this);
            this.on("pointerover", this._over, this);
            this.on("pointerout", this._out, this);
        }
    }

    set drag(value) {
        if (!this.input)
            this.input = true;

        this._isDrag = value;
        this._listenMouseUp = value;
        (this._listenMouseUp) ? Omy.mouse.addUpHandler(this._globalMouseUp, this) : Omy.mouse.removeUpMouse(this._globalMouseUp, this);
        this._dragVertical = true;
        this._dragHorizontal = true;
    }

    set allowHorizontalDrag(value) {
        this._dragHorizontal = value;
    }

    set allowVerticalDrag(value) {
        this._dragVertical = value;
    }

    set removeOnEnd(value) {
        this._removeOnEnd = value;
    }

    get isReversed() {
        return this._reverseActor;
    }

    get loopCount() {
        return this._countLoop;
    }

    set totalLoop(value) {
        this._totalLoop = value;
    }

    get totalLoop() {
        return this._totalLoop;
    }

    get fps() {
        return this._fps;
    }

    set fps(value) {
        this._fps = value;
    }

    get aName() {
        return this._aName;
    }

    get speed() {
        return this.animationSpeed / (this._fps / this._fpsGame);
    }

    set speed(value) {
        this.animationSpeed = value * (this._fps / this._fpsGame);
    }

    set interactChild(value) {
        this.interactiveChildren = value;
    }

    set putOnCache(value) {
        this._putOnCache = value;
    }

    set revert(value) {
        if (this._isRevert !== value) {
            this._isRevert = value;
            this.textures.reverse();
        }
    }

    get revert() {
        return this._isRevert;
    }
}
